import React, { useState } from "react";
import { Tag, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

export const CouponBox = () => {
  const { cart, applyCoupon, removeCoupon } = useCart();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const apply = async (e) => {
    e?.preventDefault?.();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const data = await applyCoupon(code.trim());
      toast.success(`${data.coupon.code} applied — you save ₹${data.discount}`);
      setCode("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not apply coupon");
    } finally {
      setBusy(false);
    }
  };

  if (cart.coupon || cart.coupon_error) {
    return (
      <div data-testid="coupon-applied" className={`flex items-center justify-between gap-3 rounded-xl px-4 py-3 border ${cart.coupon_error ? "border-red-300/40 bg-red-900/20" : "border-goldlight/40 bg-cream/5"}`}>
        <div className="flex items-center gap-2.5 min-w-0">
          <Tag size={14} className="text-goldlight shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-bold tracking-[0.12em] uppercase text-cream">{cart.coupon_code}</p>
            <p className={`text-[11px] ${cart.coupon_error ? "text-red-200" : "text-cream/70"}`}>{cart.coupon_error || cart.coupon.description || cart.coupon.label}</p>
          </div>
        </div>
        <button data-testid="coupon-remove-button" type="button" onClick={removeCoupon} aria-label="Remove coupon" className="p-1.5 text-cream/60 hover:text-cream transition-colors"><X size={14} /></button>
      </div>
    );
  }

  return (
    <div data-testid="cart-coupon-form" className="flex">
      <input
        data-testid="coupon-input"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); apply(); } }}
        placeholder="Coupon code"
        className="flex-1 min-w-0 bg-cream/10 border border-cream/20 rounded-l-full px-4 py-2.5 text-sm uppercase tracking-wider placeholder:normal-case placeholder:tracking-normal placeholder:text-cream/40 focus:outline-none focus:border-goldlight transition-colors"
      />
      <button type="button" onClick={apply} data-testid="coupon-apply-button" disabled={busy || !code} className="bg-cream/15 hover:bg-goldlight hover:text-forestdeep text-cream rounded-r-full px-4 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors disabled:opacity-50">
        {busy ? <Loader2 size={13} className="animate-spin" /> : "Apply"}
      </button>
    </div>
  );
};
